"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pay = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Pay = ({
  size = 22,
  width = size,
  height = size,
  fill = '#121213',
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 14 22",
  fill: fill,
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  d: "M1.76064 12.7661C1.04204 12.1122 0.989237 10.9999 1.64298 10.2815C2.29748 9.56226 3.40982 9.51063 4.12822 10.1644C4.84785 10.8192 4.89962 11.9306 4.24531 12.6496C3.59157 13.368 2.48047 13.4212 1.76064 12.7661Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M5.86366 8.26025C5.14506 7.60631 5.09227 6.49401 5.74657 5.775C6.4005 5.05639 7.5134 5.00415 8.2318 5.6579C8.95142 6.31277 9.00264 7.42475 8.34889 8.14315C7.69459 8.86217 6.58349 8.9153 5.86366 8.26025Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.93056 3.78564C9.21196 3.1317 9.15972 2.01879 9.81347 1.30039C10.4674 0.581789 11.5803 0.52955 12.2987 1.1833C13.0183 1.83816 13.0695 2.95014 12.4158 3.66854C11.7619 4.38714 10.6504 4.44069 9.93056 3.78564Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M1.70156 20.8149C0.982956 20.161 0.930157 19.0487 1.58391 18.3303C2.2384 17.6111 3.35075 17.5595 4.06915 18.2132C4.78878 18.8681 4.84056 19.9794 4.18625 20.6984C3.5325 21.4168 2.42139 21.47 1.70156 20.8149Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M5.80703 16.3032C5.08842 15.6493 5.03563 14.537 5.68993 13.818C6.34387 13.0994 7.45677 13.0471 8.17517 13.7009C8.8948 14.3557 8.94602 15.4677 8.29227 16.1861C7.63796 16.9051 6.52686 16.9583 5.80703 16.3032Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.87393 11.8325C9.15532 11.1786 9.10308 10.0657 9.75683 9.34727C10.4108 8.62867 11.5237 8.57643 12.2421 9.23018C12.9617 9.88504 13.0129 10.997 12.3592 11.7154C11.7052 12.434 10.5938 12.4876 9.87393 11.8325Z",
  fill: "#121213"
}));

exports.Pay = Pay;